import SurveyForm from '../components/SurveyForm';
import { useLocation } from 'react-router-dom';

export default function CreateSurveyPage() {
  const location = useLocation();
  const draftContent = location.state?.draftContent || '';
  const reviewText = location.state?.reviewText || '';

  return (
    <div className="page page-create-survey" style={{ maxWidth: 760, margin: '0 auto', padding: '1.5rem 1rem' }}>
      <header style={{ marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
          <h1 style={{ margin: 0, fontSize: '1.75rem' }}>Create an Anonymous Feedback Survey</h1>
          <a
            href="/guide"
            className="muted"
            style={{ fontSize: 14 }}
            target="_blank"
            rel="noopener noreferrer"
          >
            User Guide
          </a>
        </div>
        <p className="muted" style={{ margin: 0, maxWidth: 620 }}>
          Launch an anonymous feedback campaign with AI-drafted questions, shareable links, and simple response insights.
        </p>
      </header>
      <SurveyForm postContent={draftContent} reviewText={reviewText} />
    </div>
  );
}
